<div id="app-root" rte="4P">
    <!-- Global popups and dialogs -->
    <p-toast appendTo="body" [autoZIndex]="false" [style]="{ 'z-index': 11050 }" rte="4Q"></p-toast>
    <p-confirmDialog #cd appendTo="body" [baseZIndex]="10900" header="Confirm Action" rte="4R">
        <p-footer rte="4S">
            <button type="button" pButton [icon]="cd.confirmation?.rejectIcon ?? 'pi pi-times'" [label]="cd.confirmation?.rejectLabel ?? 'No'" class="p-button-secondary mr-2" (click)="cd.reject()" rte="4T"></button>
            <button type="button" pButton [icon]="cd.confirmation?.acceptIcon ?? 'pi pi-check'" [label]="cd.confirmation?.acceptLabel ?? 'Yes'" class="m-button-primary" (click)="cd.accept()" rte="4U"></button>
        </p-footer>
    </p-confirmDialog>

    <p-confirmDialog
        #cdStyle
        [key]="customDialogKey"
        appendTo="body"
        [baseZIndex]="10900"
        header="Confirm Action"
        [styleClass]="cdStyle.confirmation?.styleClass">
        <p-footer>
            <button type="button" pButton [icon]="cdStyle.confirmation?.rejectIcon ?? 'pi pi-times'" [label]="cdStyle.confirmation?.rejectLabel ?? 'No'" class="p-button-secondary mr-2" (click)="cdStyle.reject()"></button>
            <button type="button" pButton [icon]="cdStyle.confirmation?.acceptIcon ?? 'pi pi-check'" [label]="cdStyle.confirmation?.acceptLabel ?? 'Yes'" class="m-button-primary" (click)="cdStyle.accept()"></button>
        </p-footer>
    </p-confirmDialog>

    <pwa rte="4V"></pwa>
    <multi-user-form-setup></multi-user-form-setup>
    <app-auto-update></app-auto-update>
    <router-outlet></router-outlet>
</div>
